import { mediaObjectProvider } from "@/@core/http";

export const sendToServer = async (file, generateSizes = []) => {
  const response = await mediaObjectProvider.post({ file, generateSizes });
  const { contentUrl, "@id": id } = response;

  return {
    contentUrl,
    "@id": id,
  };
};
